$(document).ready(function(){

    // new Swiper('.product-media', {
    //     loop: true,
    //     effect: 'fade',
    //     nextButton: '.swiper-button-next',
    //     prevButton: '.swiper-button-prev',
    //     slidesPerView: 2,
    //     paginationClickable: true,
    //     spaceBetween: 10,
           
    //     breakpoints: {
    //         1920: {
    //             slidesPerView: 1,
    //             spaceBetween: 10,
    //         },
    //         1028: {
    //             slidesPerView: 2,
    //             spaceBetween: 30
    //         },
    //         480: {
    //             slidesPerView: 1,
    //             spaceBetween: 10
    //         }
    //     }
    // });


var swiper = new Swiper('.product-media', {
    loop: true,
    effect: 'fade',
  allowTouchMove: true,

    paginationClickable: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
  
});

});

  function handleScroll() {
            const body = document.body;
            const scrollPosition = window.scrollY;

            
            const scrollThreshold = 100;

            if (scrollPosition >= scrollThreshold) {
              
                body.classList.add('scrolled');
            } else {
              
                body.classList.remove('scrolled');
            }
        }

        
        window.addEventListener('scroll', handleScroll);

document.addEventListener('DOMContentLoaded', function() {
    const openBtn = document.querySelector('.open-fabric-btn');
    const fabricWrapper = document.getElementById('fabricSwatches');
    const body = document.body;
    if (!openBtn || !fabricWrapper) return;

    // Function to open the fabric sidebar
    openBtn.addEventListener('click', function(e) {
        e.stopPropagation(); // click bubble ko roke
        fabricWrapper.classList.add('fabric-sidebar-open');
        body.classList.add("sidebar-open");
    });

    // Close button inside sidebar
    const closeBtn = fabricWrapper.querySelector('.close-fabric');
    if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        fabricWrapper.classList.remove('fabric-sidebar-open');
        body.classList.remove("sidebar-open");
        });
    }

    // Click outside sidebar closes it
    document.addEventListener('click', function(e) {
        if (!fabricWrapper.contains(e.target) && e.target !== openBtn) {
        fabricWrapper.classList.remove('fabric-sidebar-open');
        body.classList.remove("sidebar-open");
        }
    });

    // on li hover show content
    const swatches = document.querySelectorAll(".fabric-swatch-item");
    const detailOuter = document.querySelector(".fabric-detail-outer");
    const detailImage = document.querySelector(".fabric-detail-image");
    const detailContent = document.querySelector(".fabric-detail-content");
    const closeMobileBtn = document.querySelector(".close-fabric-mobile");
    const mobileTitle = document.querySelector(".mobile-fabric-title");
    const mobileImage = document.querySelector(".mobile-fabric-image");

   swatches.forEach(item => {
        item.addEventListener("mouseenter", function () {
            const imageURL = this.dataset.fabricImage;
            const detailsHTML = this.dataset.fabricDetails;
             const variantTitle = this.querySelector(".fabric-name").textContent; // Get the variant title
            const featuredImage = this.dataset.featuredImage; // Variant featured image for mobile
            // Active class add
            detailOuter.classList.add("active");
            // Update image
            detailImage.innerHTML = `<img src="${imageURL}" alt="Fabric Image">`;
            // Update details
            detailContent.innerHTML = detailsHTML;
            // Update the mobile header (title + image)
            mobileTitle.textContent = variantTitle; // Set the title
            mobileImage.src = featuredImage; // Set the image
            mobileImage.alt = variantTitle; // Set alt text for image
        });

        item.addEventListener("mouseleave", function () {
            // If cursor is over detail box, do NOT remove active class
            const isHoveringDetailBox = detailOuter.matches(":hover");

            if (!isHoveringDetailBox) {
                detailOuter.classList.remove("active");
            }
        });

        // Adding click event to update  product with varaint name in inquiry form
        item.addEventListener("click", function () {
            const variantTitle = this.querySelector(".fabric-name").textContent; // Get the variant title
            const formField = document.getElementById("ContactFormCollection");

            // Accessing the product title from the data-title attribute
            const productTitle = formField.getAttribute("data-title");

            // Combine product title with variant title (e.g., "Garrett Armchair in Black")
            const combinedTitle = `${productTitle} in ${variantTitle}`;

            // Update the inquiry form field with the combined title (product name + variant name)
            formField.value = combinedTitle;

            const swatchTextEl = document.querySelector(".cus_swatch_text");
            // Uski HTML/text update karo variantTitle se
            if (swatchTextEl) {
                swatchTextEl.textContent = variantTitle;  // ya swatchTextEl.innerHTML = variantTitle;
            }
        });
    });

    // If mouse leaves fabric-detail-outer → remove active
    detailOuter.addEventListener("mouseleave", function () {
        detailOuter.classList.remove("active");
    });
    // for mobile only
    if (closeMobileBtn) {
        closeMobileBtn.addEventListener("click", function() {
            // Remove active class
            detailOuter.classList.remove("active");
        });
    }

    // Onchange color show slider image
      const fabricItems = document.querySelectorAll(".fabric-swatch-item");

    function initFabricClick() {
        const swiperContainer = document.querySelector(".product-media.swiper-container");
        if (!swiperContainer || !swiperContainer.swiper) {
        setTimeout(initFabricClick, 100);
        return;
        }
        const swiper = swiperContainer.swiper;

        fabricItems.forEach(item => {
        item.addEventListener("click", function() {

            // Active class toggle
            fabricItems.forEach(i => i.classList.remove("active"));
            this.classList.add("active");

            // Get variant name (lowercase)
            const variantName = this.getAttribute("get-variant-name").toLowerCase();

            // Convert swiper.slides to array
            const slidesArray = Array.from(swiper.slides);
            let targetIndex = null;

            slidesArray.forEach((slide, index) => {
            const img = slide.querySelector("img");
            if (img && img.getAttribute("data-media-alt").toLowerCase() === variantName) {
                targetIndex = index;
            }
            });

            if (targetIndex !== null) {
            swiper.slideTo(targetIndex);
            }

        });
        });
    }

    initFabricClick();
});